"use client";

import { useId, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { webSiteNavigationLabels } from "../webSiteNavigation";
import { useWebMobileMenuOverlay } from "./useWebMobileMenuOverlay";
import { useCinematicWebRuntime } from "./useCinematicWebRuntime";

export function AtelierMobileMenu({
    languageCode,
}: {
    languageCode?: string | null;
}) {
    const navigationId = useId();
    const sentinelRef = useRef<HTMLSpanElement>(null);
    const toggleRef = useRef<HTMLButtonElement>(null);
    const [isOpen, setIsOpen] = useState(false);
    const labels = webSiteNavigationLabels(languageCode);
    const header = useCinematicWebRuntime({
        headerScrolledAttribute: "data-atelier-header-scrolled",
        revealedAttribute: "data-atelier-revealed",
        revealAttribute: "data-atelier-reveal",
        runtimeReadyAttribute: "data-atelier-runtime-ready",
        sentinelRef,
        templateCode: "atelier-muse",
    });

    useWebMobileMenuOverlay({
        header,
        isOpen,
        navigationId,
        openAttribute: "data-atelier-mobile-menu-open",
        setIsOpen,
        templateCode: "atelier-muse",
        toggleRef,
    });

    return (
        <>
            <span
                aria-hidden="true"
                data-atelier-mobile-menu-runtime="true"
                ref={sentinelRef}
                style={{ display: "none" }}
            />
            {header
                ? createPortal(
                    <button
                        aria-controls={navigationId}
                        aria-expanded={isOpen}
                        aria-label={isOpen ? labels.closeMenu : labels.openMenu}
                        className="atelier-mobile-menu-toggle"
                        onClick={(event) => {
                            event.stopPropagation();
                            setIsOpen((current) => !current);
                        }}
                        onPointerDown={(event) => event.stopPropagation()}
                        ref={toggleRef}
                        type="button"
                    >
                        <span />
                        <span />
                    </button>,
                    header,
                )
                : null}
        </>
    );
}
